import { useRef, useEffect } from 'react';

/*
  Utility to have an effect that only gets run under specific circumstances.

  callback - The hook function. If it returns a function, it is used as the deregistration function as normal and the callback will only run once until allowed to reset.
  reset - A function that gets run whenever an effect hook would normally run - if it returns true, the callback function will be allowed to run the next time the hook is invoked.
  props - An array of values to watch for changes passed to the effect hook as normal.
*/
export function useEffectOnce (effect: () => void | (() => void), shouldRunAgain?: null | (() => boolean), deps?: unknown[]) {
  const useEffectRef = useRef<boolean>(false);

  useEffect(() => {
    let offEffect: () => void;

    if (!useEffectRef.current) {
      useEffectRef.current = true;

      const result = effect();
      if (typeof result === 'function') {
        offEffect = result;
      }
    }

    if (shouldRunAgain && shouldRunAgain()) useEffectRef.current = false;

    if (offEffect) return offEffect;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ ...(deps || []) ]);
}
